<template>
  <div class="row">
    <div class="col-xl-12">
      <!-- begin: Single Modal -->
      <router-view />
      <!-- end: Single Modal -->

      <div
        v-show="$route.path == '/MachineReport/LeaseMachine'"
        class="kt-portlet kt-portlet--mobile"
      >
        <div class="kt-portlet__head kt-portlet__head--lg">
          <div class="kt-portlet__head-label">
            <span class="kt-portlet__head-icon">
              <i class="fa fa-store"></i>
            </span>
            <h3 class="kt-portlet__head-title">
              {{ this.$route.meta.breadcrumb }}
            </h3>
          </div>
        </div>

        <div class="kt-portlet__body">
          <!-- begin: Search Form -->
          <form class="kt-form" ref="form" @submit.prevent="formSubmit($event)">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Phase:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'relmPhase'"
                    :name="'relmPhase'"
                    :select2-options="relmPhaseOptions"
                    v-model="relmPhase"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Lot:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'relmLot'"
                    :name="'relmLot'"
                    :select2-options="relmLotOptions"
                    v-model="relmLot"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>แบรนด์เครื่องเบียร์สด:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'relmProductBrandId'"
                    :name="'relmProductBrandId'"
                    :select2-options="relmProductBrandIdOptions"
                    v-model="relmProductBrandId"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ประเภทสินค้า:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'relmProductTypeId'"
                    :name="'relmProductTypeId'"
                    :select2-options="relmProductTypeIdOptions"
                    v-model="relmProductTypeId"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>ตัวแทนจำหน่าย:</label>
                  <!-- <label>Agent:</label> -->
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'relmCurrentAgentCode'"
                    :name="'relmCurrentAgentCode'"
                    :select2-options="relmCurrentAgentCodeOptions"
                    v-model="relmCurrentAgentCode"
                  ></select2>
                </div>
              </div>

              <div class="col-xl-3 col-lg-3 col-md-3 .col-sm-3 col-xs-3">
                <div class="form-group">
                  <label>Supplier:</label>
                  <select2
                    :css-style="'width: 100%;'"
                    :css-class="'form-control m-select2'"
                    :id="'relmCurrentVendorId'"
                    :name="'relmCurrentVendorId'"
                    :select2-options="relmCurrentVendorIdOptions"
                    v-model="relmCurrentVendorId"
                  ></select2>
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <div class="col-xl-6">
                <button type="submit" class="btn btn-primary">
                  Generate Report
                </button>
                <button
                  type="reset"
                  class="btn btn-secondary"
                  @click="formReset"
                >
                  ล้างค่าทั้งหมด
                </button>
              </div>

              <div class="col-xl-6 text-right">
                <button
                  class="btn btn-outline-primary"
                  @click="exportLeaseMachine"
                >
                  <span>
                    <i class="fas fa-file-export"></i><span>Export Excel</span>
                  </span>
                </button>
              </div>
            </div>
          </form>
          <!-- end: Search Form -->

          <!--begin: Table -->
          <div class="row">
            <div class="col-lg-12 table-responsive">
              <table
                class="table-sm table-striped- table-bordered table-hover table-checkable display nowrap"
                id="datatable"
                style="width: 100%"
              >
                <thead>
                  <tr>
                    <th class="all text-right" colspan="13">
                      ข้อมูล ณ วันที่ {{ reAaDateReq }}
                    </th>
                  </tr>
                  <tr>
                    <th class="all text-center">ชื่อตัวแทนจำหน่าย</th>
                    <th
                      v-for="data in headers"
                      class="all text-center"
                      style="width: 6%"
                    >
                      {{ data }}
                    </th>
                    <th class="all text-center">Grand Total</th>
                  </tr>
                  <tr v-for="item in database">
                    <td class="all text-center">{{ item.agentName }}</td>
                    <td
                      v-for="data in headers"
                      class="all text-center"
                      style="width: 6%"
                    >
                      {{
                        item.phase.filter((o) => o.phase == data)[0] ==
                        undefined
                          ? null
                          : item.phase.filter((o) => o.phase == data)[0].total
                      }}
                    </td>
                    <td class="all text-center">{{ item.total }}</td>
                  </tr>
                </thead>
                <tfoot>
                  <tr>
                    <th class="text-right">Grand Total</th>
                    <th v-for="data in totalPhase" class="text-center">
                      {{ data[1] }}
                    </th>
                    <th class="text-center">{{ GrandTotal }}</th>
                  </tr>
                </tfoot>
                <tbody v-show="false" id="text1"></tbody>
              </table>
            </div>
          </div>
          <!--end: Table -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import router from "../../router";
import select2 from "../../Shared/Select2";
import axios from "axios";
import DatatableWarning from "../../Shared/DatatableWarning";

require("datatables.net-autofill-bs4");
require("datatables.net-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-colreorder-bs4");
require("datatables.net-fixedcolumns-bs4");
require("datatables.net-fixedheader-bs4");
require("datatables.net-keytable-bs4");
require("datatables.net-responsive-bs4");
require("datatables.net-rowgroup-bs4");
require("datatables.net-rowreorder-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("sweetalert2");

export default {
  components: {
    select2,
  },
  data: function() {
    var self = this;

    return {
      reAaIsInitial: true,
      reAaDateReq: null,
      relmPhase: null,
      relmLot: null,
      relmProductBrandId: null,
      relmCurrentAgentCode: null,
      relmProductTypeId: null,
      relmCurrentVendorId: null,
      headers: [],
      database: [],
      phase: [],
      totalPhase: [],
      GrandTotal: null,
      relmCurrentAgentCodeOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกAgent",
        allowClear: true,
        ajax: {
          url: "/Api/Report/Select2Agent",
          type: "post",
          delay: 300,
          dataType: "json",
          contentType: "application/json",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              province_id: [],
              department: [],
              AgentCodes: [],
            };
            return JSON.stringify(query);
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      relmProductTypeIdOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกประเภทสินค้า",
        data: [
          { id: "3", text: "เครื่องทำความเย็น", data: null },
          { id: "6", text: "หัวจ่าย", data: null },
        ],
      },
      relmCurrentVendorIdOptions: {
        //minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกSupplier",
        allowClear: true,
        ajax: {
          delay: 300,
          url: "/Api/Vendors/Select2Vendor",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      relmPhaseOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกPhase",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Phase",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      relmLotOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกLot",
        allowClear: true,
        ajax: {
          url: "/Api/MasterPhase/Select2Lot",
          data: function(params) {
            var query = {
              search: params.term,
              Phase: self.relmPhase,
              page: params.page || 1,
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
      },
      relmProductBrandIdOptions: {
        // minimumResultsForSearch: -1,
        placeholder: "กรุณาเลือกแบรนด์เครื่องเบียร์สด",
        allowClear: true,
        ajax: {
          url: "/Api/ProductBrand/Select2BrandMachine",
          data: function(params) {
            var query = {
              search: params.term,
              page: params.page || 1,
              ProductType: "3,6",
            };
            return query;
          },
          processResults: function(data, params) {
            return {
              results: data.results,
              pagination: {
                more: data.more,
              },
            };
          },
          transport: function(params, success, failure) {
            params.beforeSend = function(request) {
              request.setRequestHeader(
                "Authorization",
                "Bearer " + self.$root.user.access_token
              );
            };
            var $request = $.ajax(params);
            $request.then(success);
            $request.fail(failure);
            return $request;
          },
        },
        templateResult: function(data) {
          return data.text;
        },
        language: {
          noResults: function() {
            return "ไม่พบข้อมูลร้านค้า";
          },
        },
      },
    };
  },
  computed: {},
  methods: {
    formReset: function(e) {
      let self = this;
      self.relmPhase = null;
      self.relmLot = null;
      self.relmProductBrandId = null;
      self.relmCurrentAgentCode = null;
      self.relmProductTypeId = null;
      self.relmCurrentVendorId = null;
      self.headers = [];
      self.database = [];
      self.phase = [];
      self.totalPhase = [];
      self.GrandTotal = null;

      $("#relmPhase")
        .val("")
        .trigger("change");

      $("#relmLot")
        .val("")
        .trigger("change");

      $("#relmProductBrandId")
        .val("")
        .trigger("change");

      $("#relmCurrentAgentCode")
        .val("")
        .trigger("change");

      $("#relmProductTypeId")
        .val("")
        .trigger("change");

      $("#relmCurrentVendorId")
        .val("")
        .trigger("change");

      this.formSubmit(e);
    },
    formSubmit: function(e) {
      let self = this;
      // self.headers = [];
      // self.database = [];
      // self.phase = [];
      // self.totalPhase = [];
      // self.GrandTotal = null;

      e.preventDefault();
      var table = $("#datatable").DataTable();
      table.draw();
    },
    exportLeaseMachine: function(e) {
      e.preventDefault();
      let self = this;

      if (
        !$(this.$refs.form)
          .validate()
          .form()
      ) {
        return false;
      }

      KTApp.blockPage({
        opacity: 0.05,
        message: "กำลังโหลดข้อมูล กรุณารอสักครู่...",
      });

      axios({
        method: "post",
        url: "/Api/Report/ExportMachineTransation",
        responseType: "arraybuffer",
        data: {
          Phase: self.relmPhase,
          Lot: self.relmLot,
          ProductBrandId: self.relmProductBrandId,
          CurrentAgentCode: self.relmCurrentAgentCode,
          ProductTypeId: self.reAaProductTypeId,
          CurrentVendorId: self.relmCurrentVendorId,
          ProductTypeId: self.relmProductTypeId,
        },
      })
        .then(function(response) {
          if (response.status == "200") {
            let filename = "";
            let contentType = response.headers["content-type"];
            let disposition = response.headers["content-disposition"];

            //===Get Filename===
            if (disposition && disposition.indexOf("attachment") !== -1) {
              var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
              var matches = filenameRegex.exec(disposition);
              if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, "");
              }
            }

            //Save file
            let blob = new Blob([response.data], { type: contentType });
            console.log(response.data);
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;
            link.click();
          } else if (response.status == "204") {
            Swal.fire(
              "ไม่พบข้อมูล",
              "ไม่พบข้อมูลตามเงื่อนไขที่เลือก",
              "warning"
            );
          }
        })
        .catch(function(error) {
          Swal.fire("เกิดข้อผิดพลาด", error.response.data.message, "error");
        })
        .then(function() {
          //self.formReset();
          KTApp.unblockPage();
        });
    },
    getDataFromApi(data) {
      let self = this;

      self.headers = [];
      self.database = [];
      self.phase = [];
      self.totalPhase = [];
      self.GrandTotal = null;

      data.forEach((e) => {
        self.GrandTotal = self.GrandTotal + e.total;
        e.phase.forEach((o) => {
          let chk = self.headers.includes(o.phase);
          if (!chk) {
            self.headers.push(o.phase);
          }
        });
      });
      self.headers = self.headers.sort();
      self.database = data;

      self.database.forEach((o) => {
        o.phase.forEach((i) => {
          self.phase.push(i);
        });
      });

      self.headers.forEach((e) => {
        var data = self.phase.filter((o) => o.phase == e);
        var total = 0;
        data.forEach((d) => {
          total = total + d.total;
        });

        var item = [e, total];
        self.totalPhase.push(item);
      });
    },
  },
  async mounted() {
    let self = this;
    var arrows;
    if (KTUtil.isRTL()) {
      arrows = {
        leftArrow: '<i class="la la-angle-right"></i>',
        rightArrow: '<i class="la la-angle-left"></i>',
      };
    } else {
      arrows = {
        leftArrow: '<i class="la la-angle-left"></i>',
        rightArrow: '<i class="la la-angle-right"></i>',
      };
    }
    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#datatable");
    table.DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      ajax: {
        url: "/Api/Report/MachineTransation",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          return JSON.stringify(
            $.extend(d, {
              Phase: self.relmPhase,
              Lot: self.relmLot,
              ProductBrandId: self.relmProductBrandId,
              CurrentAgentCode: self.relmCurrentAgentCode,
              ProductTypeId: self.reAaProductTypeId,
              CurrentVendorId: self.relmCurrentVendorId,
              ProductTypeId: self.relmProductTypeId,
              IsInitial: self.reAaIsInitial,
            })
          );
        },
        complete: function(response, xhr, status) {
          // console.log("response.responseJSON.data");
          // console.log(response.responseJSON.data);
          self.getDataFromApi(response.responseJSON.data);
          self.reAaIsInitial = false;
        },
      },
      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
        <'row'<'col-sm-12'tr>>
        <'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [100, 500],

      pageLength: 100,

      language: {
        lengthMenu: "Display _MENU_",
      },

      // Order settings
      order: [[0, "asc"]],
      columns: [
        {
          data: "agentCode",
          className: "text-center",
          width: "10%",
        },
        {
          data: "agentName",
          className: "text-center",
          width: "10%",
        },
      ],
    }).on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    self.reAaDateReq = moment().format("DD/MM/YYYY h:mm a");

    $(self.$refs.reInv1).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reInv1)
      .datepicker(
        "update",
        !!self.reInv1 ? self.reInv1.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reInv1 = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(self.$refs.reInv2).datepicker({
      autoclose: true,
      clearBtn: true,
      format: "dd/mm/yyyy",
      rtl: KTUtil.isRTL(),
      minDate: moment(), // Current day
      maxDate: moment().add(30, "days"), // 30 days from the current day
      orientation: "bottom left",
      todayBtn: "linked",
      todayHighlight: true,
      templates: arrows,
    });
    //self.reBcTransferJobCommitDateStart = moment().set("date",1);
    $(self.$refs.reInv2)
      .datepicker(
        "update",
        !!self.reInv2 ? self.reInv2.format("DD/MM/YYYY") : null
      )
      .on("changeDate", function(e) {
        self.reInv2 = e.dates.length != 0 ? moment(e.date) : null;
      });

    $(this.$refs.form).validate().settings.ignore = ":hidden";
  },
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// App/Components/Report/LeaseMachine.vue